
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    VISITOR_ACTION,
    ALL_VISITOR,
    ADD_VISITOR,
    FETCH_VISITOR,
    EDIT_VISITOR,
    DELETE_VISITOR,
    AVAILABLE_STUDENTS_REPORT
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * Visitors Actions
 */


    export const allVisitors = () =>{    
    
        return (dispatch) => { 
            dispatch({ type: VISITOR_ACTION });
            return axios.get(AppConfig.apiurl+'/api/getvisitor', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_VISITOR, payload: alldata });
            });
        }        
    
    }

    export const addVisitors = (data) =>{
    
        var payload={
            "name":data.target.name.value,
            "mobile":data.target.mobile.value,
            "checkindate":data.target.checkindate.value,
            "checkoutdate":data.target.checkoutdate.value,
            "ssstartdate":data.target.startdate.value,
            "ssenddate":data.target.enddate.value,
        }
        return (dispatch) => { 
            dispatch({ type:VISITOR_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addvisitor', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allVisitors()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_VISITOR});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchVisitors = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:VISITOR_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/fetchvisitor', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_VISITOR, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editVisitors = (data, id) =>{
    
        var payload={
            "id":data.target.eid.value,
            "name":data.target.name.value,
            "mobile":data.target.mobile.value,
            "checkindate":data.target.checkindate.value,
            "checkoutdate":data.target.checkoutdate.value,
            "ssstartdate":data.target.startdate.value,
            "ssenddate":data.target.enddate.value,
        }
        return (dispatch) => { 
            dispatch({ type:VISITOR_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/editvisitor', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allVisitors()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_VISITOR});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }


    export const deleteVisitors = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:VISITOR_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deletevisitor', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allVisitors()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_VISITOR});                    
                }
                
                
            });
        
        }
    }


    export const fetchAvailableReport = (seldate) =>{
    
        var payload={
            "date":seldate
        }
        return (dispatch) => { 
            dispatch({ type:VISITOR_ACTION});
            return axios.post(AppConfig.apiurl+'/api/findavailablestudent', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    dispatch({ type: AVAILABLE_STUDENTS_REPORT, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }


   

